import { APIClient } from 'services/helpers/api_helper';
import * as url from 'services/helpers/url_helper';
import {
  GetBreakingTimeByIdResponse,
  GetTimeAttendanceDailyExportResponse,
  GetTimeAttendanceMonthlyExportResponse,
  GetTimeAttendanceOfficersResponse,
  GetTimeAttendanceListResponse,
  PutUpdateBreakingTimeResponse,
  GetWorkingTimeByIdResponse,
} from 'types/APIResponsesTypes';
import {
  UpdateAttendanceBreakingTimeRequest,
  UpdateAttendanceWorkingTimeRequest,
} from 'types/timeAttendance/timeAttendanceTypes';

const api = new APIClient();

export const getTimeAttendanceList = async (
  store_ids: string,
  office_id: number | null,
  start_date: string,
  end_date: string,
  page = 1,
  limit = 25
) => {
  const params: {
    store_ids: string;
    start_date: string;
    end_date: string;
    page: number;
    limit: number;
    office_id?: number;
  } = {
    store_ids,
    start_date,
    end_date,
    page,
    limit,
  };
  if (office_id !== null) {
    params.office_id = office_id;
  }
  try {
    const response: Promise<GetTimeAttendanceListResponse> = await api.get(
      url.GET_WORKING_TIME_BY_ID,
      params
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getTimeAttendanceDailyExport = async (
  store_ids: string,
  office_id: number | null,
  start_date: string,
  end_date: string
) => {
  const params: {
    store_ids: string;
    start_date: string;
    end_date: string;
    office_id?: number;
  } = {
    store_ids,
    start_date,
    end_date,
  };

  if (office_id !== null) {
    params.office_id = office_id;
  }

  try {
    const response: Promise<GetTimeAttendanceDailyExportResponse> =
      await api.get(url.GET_TIME_ATTENDANCE_EXPORT_DAILY, params);

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getTimeAttendanceMonthlyExport = async (
  store_ids: string,
  office_id: number | null,
  start_date: string,
  end_date: string
) => {
  const params: {
    store_ids: string;
    start_date: string;
    end_date: string;
    office_id?: number;
  } = {
    store_ids,
    start_date,
    end_date,
  };

  if (office_id !== null) {
    params.office_id = office_id;
  }

  try {
    const response: Promise<GetTimeAttendanceMonthlyExportResponse> =
      await api.get(url.GET_TIME_ATTENDANCE_EXPORT_MONTHLY, params);

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
// export const getTimeAttendanceMonthlyExport = async (
//   store_ids: string,
//   yyyymm: string,
//   office_id: number | null
// ) => {
//   const params: {
//     store_ids: string;
//     yyyymm: string;
//     office_id?: number;
//   } = {
//     store_ids,
//     yyyymm,
//   };

//   if (office_id !== null) {
//     params.office_id = office_id;
//   }

//   try {
//     const response: Promise<GetTimeAttendanceMonthlyExportResponse> =
//       await api.get(url.GET_TIME_ATTENDANCE_EXPORT_MONTHLY, params);

//     return response;
//   } catch (error) {
//     return Promise.reject(error);
//   }
// };

export const getWorkingTimeById = async (id: number) => {
  try {
    const response: Promise<GetWorkingTimeByIdResponse> = await api.get(
      `${url.GET_WORKING_TIME_BY_ID}/${id}/working-time`
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getTimeAttendanceOfficers = async () => {
  try {
    const response: Promise<GetTimeAttendanceOfficersResponse> = await api.get(
      `${url.GET_TIME_ATTENDANCE}/officers`
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getBreakingTimeById = async (id: number) => {
  try {
    const response: Promise<GetBreakingTimeByIdResponse> = await api.get(
      `${url.GET_WORKING_TIME_BY_ID}/${id}/breaking-time`
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const putUpdateWorkingTime = async (
  id: string,
  req: UpdateAttendanceWorkingTimeRequest
) => {
  try {
    const response = await api.put(
      `${url.PUT_UPDATE_WORKING_TIME}/${id}/working-time`,
      req
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const putUpdateBreakingTime = async (
  breakingTimeId: string,
  req: UpdateAttendanceBreakingTimeRequest
) => {
  try {
    const response: Promise<PutUpdateBreakingTimeResponse> = await api.put(
      `${url.PUT_UPDATE_WORKING_TIME}/${breakingTimeId}/breaking-time`,
      req
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
